function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "13",
  viewBox: "0 0 16 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.198.5H9.21c1.42 0 2.57 1.307 2.57 2.918v.641l2.507-1.166c.555-.257 1.162.204 1.162.881v5.48c0 .678-.607 1.14-1.162.882L11.781 8.97v.612c0 1.611-1.15 2.918-2.57 2.918H3.198c-1.42 0-2.57-1.307-2.57-2.918V3.418C.628 1.807 1.778.5 3.198.5z",
  fill: "#fff"
})));